var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6853 22.3437C29.121 23.1562 29.1043 23.9687 28.635 24.7812C28.1992 25.5937 27.5121 26 26.5735 26H2.43863C1.50005 26 0.796115 25.5937 0.326826 24.7812C-0.108942 23.9687 -0.108942 23.1562 0.326826 22.3437L12.3943 1.21875C12.8635 0.40625 13.5675 0 14.5061 0C15.4446 0 16.1486 0.40625 16.6179 1.21875L28.6853 22.3437ZM16.115 18.6875C15.6793 18.2135 15.1429 17.9766 14.5061 17.9766C13.8692 17.9766 13.3161 18.2135 12.8468 18.6875C12.411 19.1276 12.1931 19.6693 12.1931 20.3125C12.1931 20.9557 12.411 21.5143 12.8468 21.9883C13.3161 22.4284 13.8692 22.6484 14.5061 22.6484C15.1429 22.6484 15.6793 22.4284 16.115 21.9883C16.5843 21.5143 16.819 20.9557 16.819 20.3125C16.819 19.6693 16.5843 19.1276 16.115 18.6875ZM12.2937 9.59766L12.6959 16.5039C12.6959 16.8763 12.8971 17.0625 13.2993 17.0625H15.7128C16.115 17.0625 16.3162 16.8763 16.3162 16.5039L16.7184 9.59766C16.7184 9.39453 16.6514 9.24219 16.5173 9.14062C16.4167 9.00521 16.2826 8.9375 16.115 8.9375H12.8971C12.7295 8.9375 12.5786 9.00521 12.4445 9.14062C12.344 9.24219 12.2937 9.39453 12.2937 9.59766Z",
    fill: "#FFD202"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.da9dbd10.svg";
export { ForwardRef as ReactComponent };